"use strict";
const config = require('../../../../../config/locales_json/packs/private/admin/wizard_form_local_career.json');
const language = $('body').data("language");

// Class definition
var KTWizardLocalCareer = function () {
	// Base elements
	var _wizardEl;
	//var _formEl;
	var _wizard;
	//var _validations = [];

	// Private functions
	var initWizard = function () {
		var isNew = $(".new-career-container").length > 0 ? true : false

		// Initialize form wizard
		_wizard = new KTWizard(_wizardEl, {
			startStep: 1, // initial active step number
			clickableSteps: (isNew ? false : true) // to make steps clickable this set value true and add data-wizard-clickable="true" in HTML for class="wizard" element
		});

		// Validation before going to next page
		_wizard.on('beforeNext', function (wizard) {
			// Don't go to the next step yet
			_wizard.stop();

			//render_review_form()
			//_wizard.goNext();

			var actualStep = $(wizard)[0]["currentStep"]
			// Formulario de crear cliente
			if(actualStep == 1){
				//_wizard.goNext();

				// Se validan los campos
				var formLocalCareer = check_inputs_form("local-career-step-1");

				if(!formLocalCareer){
					const errorAlertText = getTranslationValue(config, [language, "KTWizardLocalCareer", "not_formLocalCareer"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados.")
					error_alert(errorAlertText)
				} else {
					render_review_form()
					_wizard.goNext();
				}
			}
		});

		// Change event
		_wizard.on('change', function (wizard) {
			KTUtil.scrollTop();
		});
	}

	var check_inputs_form = function (form) {
		var error = 0;
		var container = $('#'+form+'');
		var inputs = container.find($("input").not(".optional"));
		var selects = container.find($("select").not(".optional"));
		var textareas = container.find($("textarea").not(".optional"));

		const errorMsgText = getTranslationValue(config, [language, "KTWizardLocalCareer", "check_inputs_form", "errorMsgText"], "Debes completar este campo.");
		const errorWithoutOptionsText = getTranslationValue(config, [language, "KTWizardLocalCareer", "check_inputs_form", "errorWithoutOptionsText"], "Debes agregar al menos una opción.");

		var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorMsgText+'</div></div>';
		var errorWithoutOptions = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorWithoutOptionsText+'</div></div>';

		inputs.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "" && typeof inputName != "undefined") {
				if (inputType == "radio" || inputType == "checkbox") {
					inputName = $(this).attr('name');
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Validamos si este input esta dentro de un checkbox list
					if(contInput.hasClass("checkbox-list")){
						// Cambia el contInput
						contInput = $(this).parent().parent().parent();
					}

					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Revisa si esta activada la opcion
					var isChecked = $('input[name="'+ inputName +'"]:checked').length;
					// Si no esta chequeado
					if (isChecked == 0) {
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						contInput.find(".fv-plugins-message-container").remove()
					}
				} else if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.find(".fv-plugins-icon-container").append(errorMsg);
							// Le suma al contador de errores
							error++;
						// Si el input esta correcto
						} else {
							// Agrega el icono al input
							contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.find(".fv-plugins-icon-container").addClass("has-success");
						}
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Si el input esta vacio
						if (!$(this).val()) {
							// Agrega el icono al input
							$(this).addClass("is-invalid");
							// Agrega la clase de has-danger al contenedor del input
							contInput.addClass("has-danger");
							// Se muestra el mensaje de error
							contInput.append(errorMsg);
							// Le suma al contador de errores
							error++;
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}
					}

				} else if (inputType == "file") {
					// Remueve el icono de alerta o success del input
					$(this).removeClass("is-invalid");
					$(this).removeClass("is-valid");
					// Cambia el contInput
					contInput = $(this).parent().parent().parent();
					// Remueve la clase de has-danger y has-success al contenedor del input
					contInput.removeClass("has-danger");
					contInput.removeClass("has-success");
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
					// Si el input esta vacio
					if (!$(this).val()) {
						// Agrega el icono al input
						$(this).addClass("is-invalid");
						// Agrega la clase de has-danger al contenedor del input
						contInput.addClass("has-danger");
						// Se muestra el mensaje de error
						contInput.append(errorMsg);
						// Le suma al contador de errores
						error++;
					} else {
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		selects.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si el input esta vacio
				if ($(this).val().length == 0) {
					// Si es multiple
					if(hasMultiple) {
						// Al input con la clase tt-input le va a agregar la clase form-control para que muestre
						// el icono
						$(this).parent().find(".tt-input").addClass("form-control");
						// Cambia el icono de invalido por valido
						$(this).parent().find(".tt-input").removeClass("is-valid").addClass("is-invalid");
					}

					// Si es selectized
					if(hasSelectized) {
						// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
						// cambie el icono de valido por invalido
						$(this).parent().find(".selectize-control").removeClass("is-valid").addClass("is-invalid");
					}

					$(this).addClass("is-invalid");
					contInput.addClass("has-danger");
					contInput.append(errorMsg);
					error++;
				} else {
					// Debemos validar el formulario de preguntas para las preguntas con opciones.
					// Asi que primero detectamos que select es una preguna del formulario
					var hasQuestionSelect = $(this).hasClass("filter_question_enum_type")
					// Si es un select del formulario de preguntas
					if(hasQuestionSelect) {
						// Si la pregunta es de los tipo con opciones
						if ($(this).val() == "2" || $(this).val() == "3" || $(this).val() == "4") {
							// Obtiene las opciones que hay
							var optionsQuestion = $(this).parent().parent().parent().find(".cont-option-question-filter").children()
							// Si hay opciones se valida correctamente
							if(optionsQuestion.length > 0){
								// Agrega el icono al input
								$(this).addClass("is-valid");
								// Agrega la clase de has-success al contenedor del input
								contInput.addClass("has-success");
							// Si no tiene opciones
							} else {
								$(this).addClass("is-invalid");
								contInput.addClass("has-danger");
								contInput.append(errorWithoutOptions);
								error++;
							}
						// Si la pregunta es de un tipo texto
						} else {
							// Agrega el icono al input
							$(this).addClass("is-valid");
							// Agrega la clase de has-success al contenedor del input
							contInput.addClass("has-success");
						}

					// De lo contrario es un select normal y se valida correctamente
					} else {
						// Si es multiple
						if(hasMultiple) {
							// Cambia el icono de invalido por valido
							$(this).parent().find(".tt-input").removeClass("is-invalid").addClass("is-valid");
						}

						// Si es selectized
						if(hasSelectized) {
							// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
							// cambie el icono de valido por invalido
							$(this).parent().find(".selectize-control").removeClass("is-invalid").addClass("is-valid");
						}

						// Agrega el icono al input
						$(this).removeClass("is-invalid").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				}
			}
		})

		textareas.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Si el input esta vacio
				if (!$(this).val()) {
					// Agrega el icono al input
					$(this).addClass("is-invalid");
					// Agrega la clase de has-danger al contenedor del input
					contInput.addClass("has-danger");
					// Muestra el mensaje de error
					contInput.append(errorMsg);
					error++;
				} else {
					// Agrega el icono al input
					$(this).addClass("is-valid");
					// Agrega la clase de has-success al contenedor del input
					contInput.addClass("has-success");
				}
			}
		})

		// Se coloca el simbolo de ok a los campos que no son obligatorios
		var inputsNotOptional = container.find($("input.optional"));
		var selectsNotOptional = container.find($("select.optional"));
		var textareasNotOptional = container.find($("textarea.optional"));

		inputsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var inputType = $(this).attr('type');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				if (inputType == "text" || inputType == "date" || inputType == "number" || inputType == "hidden") {
					// Si es un campo hidden obligatorio es porque es un typeahead
					if (inputType == "hidden") {
						// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
						contInput = $(this).parent().parent();
						// Remueve el icono de alerta o success del input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-invalid");
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").removeClass("is-valid");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-icon-container").find(".fv-plugins-message-container").remove()
						// Remueve la clase has-danger o has-success del contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Agrega el icono al input
						contInput.find(".fv-plugins-icon-container").find(".twitter-typeahead").find(".tt-input").addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.find(".fv-plugins-icon-container").addClass("has-success");
					// Si son inputs normales
					} else {
						// Remueve el icono de alerta o success del input
						$(this).removeClass("is-invalid");
						$(this).removeClass("is-valid");
						// Remueve la clase de has-danger y has-success al contenedor del input
						contInput.removeClass("has-danger");
						contInput.removeClass("has-success");
						// Se busca el mensaje de error y lo elimina
						contInput.find(".fv-plugins-message-container").remove()
						// Agrega el icono al input
						$(this).addClass("is-valid");
						// Agrega la clase de has-success al contenedor del input
						contInput.addClass("has-success");
					}
				} else if (inputType == "checkbox") {
					// Sobre escribe el contInput con el elemento que corresponde (En el caso de los typeahead forman un nuevo arbol)
					contInput = $(this).parent().parent();
					// Se busca el mensaje de error y lo elimina
					contInput.find(".fv-plugins-message-container").remove()
				}
			}
		})

		selectsNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Revisamos si el select es multiple
				var hasMultiple = $(this).attr("multiple")
				// Revisamos si el select es selectized
				var hasSelectized = $(this).hasClass("selectized")
				// Si es multiple
				if(hasMultiple) {
					// Cambia el icono de invalido por valido
					$(this).parent().find(".tt-input").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}
				// Si es selectized
				if(hasSelectized) {
					// Al div con la clase selectize-control le va a agregar la clase is-invalid para que
					// cambie el icono de valido por invalido
					$(this).parent().find(".selectize-control").removeClass("is-invalid").removeClass("is-valid").addClass("is-valid");
				}

				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		textareasNotOptional.each(function() {
			var inputName = $(this).attr('name');
			var contInput = $(this).parent();

			if(inputName != null && inputName != "") {
				// Remueve el icono de alerta o success del input
				$(this).removeClass("is-invalid");
				$(this).removeClass("is-valid");
				// Remueve la clase de has-danger y has-success al contenedor del input
				contInput.removeClass("has-danger");
				contInput.removeClass("has-success");
				// Se busca el mensaje de error y lo elimina
				contInput.find(".fv-plugins-message-container").remove()
				// Agrega el icono al input
				$(this).addClass("is-valid");
				// Agrega la clase de has-success al contenedor del input
				contInput.addClass("has-success");
			}
		})

		return error == 0 ? true : false;
	}

	var render_review_form = function() {
		// Esto es del primer paso del wizard
		// Asigna la infromacion a las variables		
		var careerName = $("#local-career-form #local_career_name").val()
		var careerCountry = $("#local-career-form #local_career_country option:selected").text()

		//console.log(careerName)
		//console.log(careerCountry)

		// Reemplaza la información que existan en los elementos por el de la variable
		$("#local-career-form #item_name span").text(careerName)
		$("#local-career-form #item_country span").text(careerCountry)
	}

	var error_alert = function(msg) {
		Swal.fire({
			text: msg,
			icon: "error",
			buttonsStyling: false,
			confirmButtonText: getTranslationValue(config, [language, "KTWizardLocalCareer", "error_alert", "swalfire_confirmButtonText"],"Aceptar"),
			customClass: {
				confirmButton: "btn btn-fj-purple"
			}
		}).then(function () {
			KTUtil.scrollTop();
		});
	}

	return {
		// public functions
		init: function () {
			_wizardEl = KTUtil.getById('kt_wizard_local_career');
			//_formEl = KTUtil.getById('kt_form');

			// Se obtiene el campo kt_wizard_local_career
			var wizardClient = $('#kt_wizard_local_career')
			// Si existe el campo
			if (wizardClient.length > 0) {
				initWizard();
			}
		}
	};
}();

jQuery(document).ready(function () {
	KTWizardLocalCareer.init();

	/*************
    * CREAR / EDITAR CARRERA
    *
    * - Logica de activacion de campo pais como autocompletar (typeahead)
    * - Validacion y ejecución del formulario
    */

	// Se aplica selectize en el campo compañia
	$('#local_career_country').selectize({
		create: false
	})

	// Envio de creacion/edicion de clientes
	var localCareerForm = $("#kt_wizard_local_career #local-career-form")
	localCareerForm.on("click", ".action-submit", function(e){
		const disabledText = getTranslationValue(config, [language, "localCareerForm_on_click_action_submit"], "Enviando Información...")
		$(this).addClass("disabled").text(disabledText);
		localCareerForm.addClass("disabled")
		localCareerForm.submit();
	})
	/*************
  	* FIN CREAR / EDITAR CARRERA
  	*/
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}
